export default __webpack_public_path__ + "static/media/pencil.aa75b41c.svg";